import React from 'react';
import { Link } from 'react-router-dom';
import FundingNotice from './FundingNotice';

const Footer = () => {
  return (
    <footer className="py-4 bg-black">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">Product</h3>
            <ul className="space-y-3">
              <li>
                <a href="/#features" className="text-sm text-white hover:text-cloudima-blue">
                  Features
                </a>
              </li>
              <li>
                <a href="/#workflow" className="text-sm text-white hover:text-cloudima-blue">
                  Workflow
                </a>
              </li>
              <li><button className="text-sm text-white hover:text-cloudima-blue">Security</button></li>
              <li><button className="text-sm text-white hover:text-cloudima-blue">Roadmap</button></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">Resources</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-white hover:text-cloudima-blue">About</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-white hover:text-cloudima-blue">About us</Link></li>
              <li><button className="text-sm text-white hover:text-cloudima-blue">Blog</button></li>
              <li><a href="mailto:contact@cloudima.org" className="text-sm text-white hover:text-cloudima-blue">Contact us</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">Legal</h3>
            <ul className="space-y-3">
              <li><Link to="/privacy" className="text-sm text-white hover:text-cloudima-blue">Privacy</Link></li>
              <li><Link to="/terms" className="text-sm text-white hover:text-cloudima-blue">Terms</Link></li>
              <li><Link to="/cookies" className="text-sm text-white hover:text-cloudima-blue">Cookies</Link></li>
              <li><Link to="/license" className="text-sm text-white hover:text-cloudima-blue">Licenses</Link></li>
            </ul>
          </div>
        </div>

        <FundingNotice />

        <div className="mt-4 pt-4 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center gap-2 mb-4 md:mb-0">
            <span className="text-xl font-display font-bold text-white">cloudima</span>
            <span className="text-sm text-gray-400">© {new Date().getFullYear()} Cloudima. All rights reserved.</span>
          </div>
          <div className="flex items-center space-x-6">
            <button
              onClick={() => window.open('https://www.linkedin.com/company/cloudima', '_blank')}
              className="text-gray-400 hover:text-cloudima-blue"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.25c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 11.25h-3v-5.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5v5.5h-3v-10h3v1.5c.69-.94 1.79-1.5 3-1.5 2.21 0 4 1.79 4 4v6z"></path>
              </svg>
            </button>
            <button
              onClick={() => window.open('https://x.com/cloudima_ai', '_blank')}
              className="text-gray-400 hover:text-cloudima-blue"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.723-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-2.717 0-4.917 2.2-4.917 4.917 0 .386.044.762.128 1.124-4.083-.205-7.702-2.159-10.126-5.134-.423.725-.666 1.562-.666 2.457 0 1.694.863 3.188 2.175 4.065-.802-.026-1.558-.246-2.217-.616v.062c0 2.366 1.684 4.342 3.918 4.788-.41.111-.843.171-1.287.171-.315 0-.623-.031-.923-.088.624 1.951 2.432 3.374 4.576 3.414-1.676 1.314-3.791 2.098-6.086 2.098-.395 0-.785-.023-1.17-.068 2.168 1.39 4.743 2.204 7.514 2.204 9.025 0 13.965-7.478 13.965-13.965 0-.213-.005-.426-.014-.637.961-.695 1.797-1.562 2.457-2.549z"></path>
              </svg>
            </button>
            <button
              onClick={() => window.open('https://www.instagram.com/cloudima.ai/', '_blank')}
              className="text-gray-400 hover:text-cloudima-blue"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zM12 7a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm5.25-.75a.75.75 0 110 1.5.75.75 0 010-1.5z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
